import ImagesScrollbarGallery from "@components/ImagesScrollbarGallery";
import cx from "classnames";
import styles from "./OurCollection.module.scss";
import { usePageContext } from "@providers/PageProvider";
import { artPage } from "@utils/helper";
import _ from "lodash";

const View = () => {
  const { pageData } = usePageContext();
  const collection: any = artPage.formatCollection(pageData);
  return (
    <section data-scroll-section className={styles.section}>
      <div className={cx("ama-title", styles.title)}>
        {_.get(collection, "title")}
      </div>
      <div className={cx(styles.swiperWrapper)}>
        <ImagesScrollbarGallery
          galleryName={"swiper-room-images"}
          images={_.get(collection, "images")}
        />
      </div>
    </section>
  );
};

export default View;
